module.exports = __webpack_public_path__ + "static/media/sega.a397b961.png";